/* eslint-disable react-hooks/exhaustive-deps */
import { ArtButton, DAOButton } from "components/button";
import Selection, { getWalletOptions } from "components/input/select-input";
import { ContractType, CustomerInterface } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
import { Modal } from "semantic-ui-react";
import { api, ui, utils } from "services";
import { useInterval } from "services/useInterval";

export default function TicketStake({ open, onClose, unit, onSuccess }: any) {
  const [amount, setAmount] = useState(0);
  const dispatch = useDispatch();
  const [ticketAmount, setTicketAmount] = useState(0);
  const [ticketType, setTicketType] = useState("");
  const [value, setValue] = useState(0);
  const [isListeningTicket, setIsListeningTicket] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state: RootState) => state.user);
  const wallets = useSelector((state: RootState) => state.wallets);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation();
  const loginType = useSelector((state: RootState) => state.logintype);

  useEffect(() => {
    if (user?.[CustomerInterface.id]) {
      let data = getWalletOptions(wallets) ?? [];
      setOptions(data);
      let idx = data.find((i) => i.value == loginType)
      if (idx) {
        setValue(idx.value)
      } else {
        data.length > 0 && setValue(data[0].value)
      }
    }
  }, [wallets, loginType])

  useInterval(async () => {
    if (window.sessionStorage.getItem("token")) {
      let messages: any = { data: [] };
      if (isListeningTicket) {
        messages = await api.getMessages("user_ft_balance_update")
      }
      if (messages.data.length > 0) {
        ui.alertSuccess(
          "Transaction successful !",
          <>
            Your in-game balance has just charged
            <img className="h-6 w-6 mb-1 mx-1 inline-block" src={`/assets/images/items/${ticketType.replace("_", "-")}.svg`} alt="ticket" />
            {ticketAmount}
          </>,
        );
        let rs = await api.post("/dao/get-customer-info", {});
        dispatch(bulkSetUserInfo(rs));
        setIsListeningTicket(false);
        setTicketType("");
      }
    }
  }, 5000)

  async function onSubmit() {
    if (!amount) { return }
    setLoading(true);
    let isWalletConnect = sessionStorage.getItem("isWalletConnect");
    if (isWalletConnect) {
      throw new Error("not_support_walletconnect");
    }
    api.depositTicket(String(amount), null, unit).then(
      (rs) => {
        onSuccess()
        // setIsListeningTicket(true);
        close();
        ui.alertSuccess("Stake successful !", "Please wait 5 minutes to update ticket in your wallet !")
        setTicketAmount(amount)
        // @ts-ignore
        setTicketType(ContractType[unit])
      },
      (err) => {
        close();
        setLoading(false);
        if (err.message === "Already processing eth_requestAccounts. Please wait.") {
          ui.alertFailed("Transaction failed !", "Please connect your metamask extension in browser first !");
        } else {
          ui.alertFailed("Transaction failed !", t(err.message));
        }
      }
    );
  }
  function close() {
    setAmount(0);
    setLoading(false);
    onClose();
  }

  return (
    <Modal
      size="small"
      open={open}
      style={{ width: "unset" }}
    >
      <div
        className="max-w-[564px] w-screen relative"
      >
        <div className="text-red cursor-pointer absolute float-right right-4 top-3"
          onClick={() => {
            if (!loading) {
              close();
            }
          }}
        >
          <img src="/assets/images/icons/close-popup.png" alt="close" className="" />
        </div>
        <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
          <div>
            <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
              {t("stake")}
            </div>
            <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

            <div className="w-11/12 mx-auto">

              <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                <div className="relative w-full">
                  <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                    <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                    <div className="flex">
                      <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                    </div>
                  </div>
                  <Selection
                    setValue={setValue}
                    options={options}
                    disabled={loading}
                    theme="dark"
                  />
                </div>
              </div>

              <div className="text-center text-white flex mx-auto justify-center w-full overflow-hidden rounded-lg ">
                <div className="relative w-full">
                  <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                    <span className="text-gray text-sm mt-1">{t("amount")}</span>
                    <img className="h-6 w-6 mt-1" src={`/assets/images/items/${unit.replace('_', '-')}.svg`} alt="coin" />
                  </div>
                  <input
                    type="text"
                    className="text-sm font-semibold block w-full h-[54px] pl-11 pt-5 text-[#E4E4E4] border border-r-0 border-input bg-[#1F1D24] rounded-l-md"
                    value={amount}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e: any) => {
                      const available = utils.getWalletToken(user, unit);
                      let value = e.target.value;
                      value = Number(value) > Number(available) ? available : value;
                      setAmount(value)
                    }}
                  />
                </div>
                <div
                  className="unselectable bg-[#1F1D24] h-[54px] px-4 text-center pt-[19px] font-medium cursor-pointer text-[#E89F01] border border-l-0 border-input rounded-r-md"
                  style={{
                    // borderLeft: "1px solid #7C6F5F",
                  }}
                  color="yellow"
                  onClick={(evt) => {
                    evt.preventDefault();
                    const available = utils.getWalletToken(user, unit);
                    setAmount(available);
                  }}
                >
                  {t("max")}
                </div>
              </div>

              <div className="font-normal text-[#999999] mt-3 text-sm">
                {t("Balance")}: {" "}
                <span>
                  <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/${unit.replace('_', '-')}.svg`} alt="coin" />
                  {utils.convertToInternationalCurrencySystem(utils.getWalletToken(user, unit))}
                </span>
              </div>
            </div>

            <div className="flex w-[112px] gap-4 mt-5 text-center items-center mx-auto">
              <DAOButton
                color="white"
                theme="orange"
                className="py-4"
                disabled={!amount || Number(amount) <= 0}
                loading={loading}
                onClick={async () => {
                  await onSubmit();
                }}
              >
                {t("stake")}
              </DAOButton>
            </div>
          </div>
        </div>
      </div>
    </Modal >
  );
}
